import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import "rxjs/add/operator/filter";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  isdisable = false;
  utm_source: string;
  constructor(private route: ActivatedRoute) {
    console.log(JSON.parse(localStorage.getItem("utm_sources")));
    let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
    console.log(IsPhonepe);
    if (IsPhonepe == "phonepe") {
      this.isdisable = true;
    }
  }

  ngOnInit() {
    setTimeout(() => {
      let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
      if (IsPhonepe == "phonepe") {
        this.isdisable = true;
      }
    }, 2000);
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/footer/footer.component.ts